module.exports = __webpack_public_path__ + "static/fonts/Poppins-ExtraBold.d45bdbc.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Poppins-ExtraBold.ttf
// module id = 1023
// module chunks = 11